<template>
  <div class="APP-BOX clearfix">

    <div class="block clearfix" :style="backImg">
      <div class="block-n clearfix">
        <form class="tagContenta sia">
          <div class="div01">
            <input class="input01" v-model="bindData.mobile" type="number" placeholder="请输入手机号">
          </div>

          <div class="div02  clearfix" v-show="graphShow">
            <input class="input02" v-model="bindData.graphCode" type="number" placeholder="请输入验证码">
            <span class="span03"><img :src="graphCodeImg" height="50px" width="125px"/></span>
          </div>

          <div class="div01 div02  clearfix">
            <input type="number" v-model="bindData.verifyCode" class="code" placeholder="请输入手机验证码" required
                   maxlength="6">
            <input type="button" :disabled="verifyCodeBtn" class="obtain generate_code" :value="verifyCodeBtnVal"
                   @click="getVerifyCode">
          </div>
          <a class="a01" @click="wxPreBind" >绑定</a>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
    import * as cookieUtil from '@/utils/cookieUtil'
    import loginService from '@/services/login-service'
    import commonService from '@/services/common-service'
    import commonUtil from '@/utils/commonUtil'
    import store from '@/store/index'
    import {Toast} from 'mint-ui'
    import '@/style/common.css'
    import customerService from '@/services/customer-service'

    export default {
        data () {
            return {
                backImg: commonUtil.setBackImg('top-'),
                code: this.$route.query.code || '',
                token: cookieUtil.get('token') || '',
                graphShow: false,
                countdown: 60,
                verifyCodeBtn: false,
                verifyCodeBtnVal: '获取验证码',
                graphCodeImg: '',
                bindData: {
                    mobile: '',
                    graphCode: '',
                    verifyCode: '',
                    openId: '',
                    sequenceKey: ''
                },
                btnPreBindState: 0,
            }
        },
        methods: {
            goBack () {
                this.$router.go(-1)
            },
            settime () {
                if (this.countdown == 0) {
                    this.getGraphCode();
                    this.verifyCodeBtn = false;
                    this.verifyCodeBtnVal = '获取验证码';
                    this.countdown = 60;
                    return
                } else {
                    this.verifyCodeBtn = true;
                    this.verifyCodeBtnVal = '重新发送(' + this.countdown + ')';
                    this.countdown--;
                }
                setTimeout(() =>
                        this.settime()
                    , 1000)
            },
            getVerifyCode () {
                const params = {
                    mobile: this.bindData.mobile,
                    graphCode: this.bindData.graphCode
                };
                loginService.getVerifyCode(params).then((res) => {
                    if (res.statusCode == 200) {
                        this.settime();
                        this.hideGraphCode();
                    } else if (res.statusCode == 1007 || res.statusCode == 1008) {
                        // 需要图形验证码或者验证码不正确
                        this.getGraphCode();
                    } else if (res.statusCode == 514) {
                        // 频繁发送
                        this.settime();
                    }
                    //else if (res.statusCode == 1001) {Toast(res.message);}格式不正确
                    Toast(res.message);
                }).catch((err) => {
                    console.log(err)
                })
            },
            getGraphCode () {
                loginService.getGraphCode().then((res) => {
                    this.graphCodeImg = res
                    this.graphShow = true
                })
            },
            hideGraphCode () {
                this.graphCodeImg = '';
                this.graphShow = false;
            },
            wxPreBind () {
                if (this.btnPreBindState == 1) {
                    Toast('请勿重复提交，若等待过长时间，请刷新后尝试');
                    return;
                }
                this.btnPreBindState = 1;
                let formData = new FormData();
                const mobile = this.bindData.mobile;
                const openId = this.bindData.openId;
                formData.append('appId', commonUtil.getAppId());
                formData.append('openId', this.bindData.openId);
                formData.append('mobile', this.bindData.mobile);
                formData.append('verifyCode', this.bindData.verifyCode);
                formData.append('key', this.bindData.sequenceKey);
                customerService.wxPreBind(formData).then((res) => {
                    if (res.statusCode !== 200) {
                        this.btnPreBindState = 0;
                        Toast(res.message);
                    } else {
                        if (res.data.exist) {
                            // 系统存在这个用户
                            this.$router.push({
                                path: '/customer', query: {
                                    sequenceKey: res.data.key,
                                    mobile: mobile,
                                    edit: false,
                                    canModifyCusName: res.data.canModifyCusName,
                                    openId: openId
                                }
                            })
                        } else {
                            this.$router.push({
                                path: '/customer', query: {
                                    sequenceKey: res.data.key,
                                    mobile: mobile,
                                    edit: true,
                                    canModifyCusName: true,
                                    openId: openId
                                }
                            })
                        }
                    }
                }).catch((err) => {
                    this.btnPreBindState = 0;
                    console.log(err);
                })
            },
            wxLogin () {
                let formData = new FormData();
                formData.append('appId', commonUtil.getAppId());
                formData.append('code', this.code);
                // 调用微信登陆接口online
                loginService.wxLogin(formData).then((res) => {
                    if (res.statusCode == 200) {
                        if (res.data.bound) {
                            // 绑定了  返回会有token  保存到cookie中 重定向到原来要访问的页面
                            cookieUtil.set('token', res.data.token)
                            store.dispatch('GetCustomerInfo').then((res) => {
                                if (res.statusCode == 200) {
                                    this.$router.push(cookieUtil.get('redirectUrl'))
                                }
                            })
                        } else {
                            // 未绑定 保存key  后面绑定用
                            this.bindData.sequenceKey = res.data.key
                            this.bindData.openId = res.data.openId
                        }
                    } else {
                        Toast(res.message)
                    }
                }).catch((err) => {
                    console.log(err)
                })
            }
        },
        created () {
            if (this.code) {
                this.wxLogin()
            } else if (this.token) {
                // 刷新token
                console.log(this.token)
            } else {
                commonService.authLoginWithWX()
            }
            // cookieUtil.set('token', 'eyJ0eXAiOiJKV1QiLCJjdHkiOiJKV1QiLCJ6aXAiOiJERUYiLCJhbGciOiJSUzUxMiJ9.eNqqVsrNT8rMSVWyUjI0tbQ0M7KwMDY0UdJRykxRsrIwBYoZ6iiVFqcW-SXmghQVFwPlUisKlKwMTU3NDY1NLSwMawEAAAD__w.L2YPuPgWdzQej1M0jutiaV6CEXVmglGrNQwZIuOSFJNNbWpfaWA28DGfkVKkzvWxwaKtGEEohrpL6PvvyeNcVGbfp9zIs7uXeBpJJdlX5zNiV2tcJvos_lgsrmTs_XzzoDFF6tciFWYOXsUFXsEKCzAAAHFejbi9g9NCdHwesRs')
            // store.dispatch('GetCustomerInfo')

            // this.code = 'afdfad'
            // this.wxLogin()
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Login.vue